import React, { useState } from "react";
import { format } from "date-fns";
import { minus, plusIcon } from "../../../../assetData/icons";

const CellDropDown = ({
  cell,
  rowId,
  valueToGet,
  isDropDownVisible,
  setRowData,
  setIsEdit,
  setSelectedItemId,
  setRejectedId,
  setRowIdAndHideShow,
}) => {
  const [selectedRowId, setselectedRowId] = useState();
  const [isHover, setIsHover] = React.useState(false);
  const [hoveredRowId, setHoveredRowId] = React.useState(null);

  const handleEdit = (item) => {
    setRowData(item);
    setIsEdit(true);
    setSelectedItemId(item?.id);
    setselectedRowId(item?.id);

    const childs = rowId?.row?.original?.childs
      ?.filter((items) => items.id !== item?.id)
      ?.map((items) => items.id);
    setRejectedId(childs);
  };

  const hoverEffect = (rowId) => {
    setIsHover(true);
    setHoveredRowId(rowId);
  };

  const removeHover = () => {
    setIsHover(false);
    setHoveredRowId(null);
  };

  let a = {
    B: "Bonus",
    S: "Split",
    R: "Reduction",
    C: "Consolidation",
    A: "Merger",
    X: "Demerger",
    D: "Dividend",
    G: "Right",
  };

  return (
    <>
      {valueToGet === "script_name" && (
        <div
          onMouseOver={() => hoverEffect(cell.id)}
          onMouseLeave={removeHover}
          onClick={() => setRowIdAndHideShow(cell)}
          className="z-[1000] flex h-[26px] w-[200px]  items-center gap-1 whitespace-nowrap  px-2 "
        >
          <img
            src={
              isDropDownVisible && rowId.row.id === cell.id.split("_")[0]
                ? minus
                : plusIcon
            }
            alt=""
            className="hover:scale-[1.0]"
          />
          <div
            className=" w-[200px]"
            onMouseOver={() => hoverEffect(cell.id)}
            onMouseLeave={removeHover}
          >
            <div className="w-[100px] whitespace-nowrap  text-black">
              {cell.getValue()?.length > 20
                ? cell.getValue().substring(0, 20) + "..."
                : cell.getValue()}
            </div>
          </div>
          {isHover &&
            hoveredRowId === cell.id &&
            cell.getValue()?.length > 20 && (
              <span className="absolute  z-[1000] mt-[58px] w-[500px]  whitespace-normal rounded bg-[#D9D9D9] p-[4px] text-[#636363]">
                {cell.getValue()}
              </span>
            )}
        </div>
      )}
      <div className="ml-[-2.5px] w-[111.6%] transition delay-1000 ease-in-out">
        {rowId?.row?.id === cell.id.split("_")[0] && isDropDownVisible && (
          <span className="">
            {cell.row.original.childs.map((item, i) => (
              <span
                key={i}
                className={`${
                  (item["caa_status"] === "P" &&
                    item["addl_status"] === null) ||
                  (item["caa_status"] === "P" && item["addl_status"] === "O")
                    ? "bg-gray-200"
                    : " pointer-events-none bg-gray-300 opacity-70 "
                  // : "bg-gray-200"
                } block w-full border-[1px] border-x-0 border-b-0 border-neutral-clr-300  px-[2px]  text-[14px] text-black `}
              >
                {valueToGet === "i" ? (
                  <span
                    className={`flex h-[24px] items-center justify-start px-[2px] `}
                  >
                    {item[valueToGet]}
                  </span>
                ) : valueToGet === "inputile_id" ? (
                  <span
                    className={`flex h-[24px] items-center justify-start px-[2px] `}
                  >
                    {item[valueToGet]}
                  </span>
                ) : valueToGet === "script_name" ? (
                  <span
                    className={`ml-[15px] whitespace-nowrap flex h-[24px] w-[190px] items-center justify-start px-[2px] `}
                  >
                    {item[valueToGet]?.length > 20
                      ? item[valueToGet].substring(0, 20) + "..."
                      : item[valueToGet]}
                  </span>
                ) : valueToGet === "face_value" ? (
                  <span
                    className={`flex h-[24px] items-center justify-end px-[6px] `}
                  >
                    {item[valueToGet] === "nan"
                      ? ""
                      : Number(item[valueToGet]).toFixed(2)}
                  </span>
                ) : valueToGet === "corpaction_tag" ? (
                  <span
                    className={`flex h-[24px] items-center justify-start px-[2px] `}
                  >
                    {a[item[valueToGet]]}
                  </span>
                ) : valueToGet === "bookclose_recorddate" ? (
                  <span
                    className={`flex h-[24px] items-center justify-start px-[2px] `}
                  >
                    {item[valueToGet] &&
                      format(new Date(item[valueToGet]), "dd MMM yyyy")}
                  </span>
                ) : valueToGet === "nse_exdate" ? (
                  <span
                    className={`flex h-[24px] items-center justify-start px-[2px] `}
                  >
                    {item[valueToGet] &&
                      format(new Date(item[valueToGet]), "dd MMM yyyy")}
                  </span>
                ) : valueToGet === "bse_exdate" ? (
                  <span
                    className={`flex h-[24px] items-center justify-start px-[2px] `}
                  >
                    {item[valueToGet] &&
                      format(new Date(item[valueToGet]), "dd MMM yyyy")}
                  </span>
                ) : valueToGet === "price" ? (
                  <span
                    className={`flex h-[24px] items-center justify-end px-[9px] `}
                  >
                    {item[valueToGet] === "nan"
                      ? ""
                      : Number(item[valueToGet]).toFixed(2)}
                  </span>
                ) : valueToGet === "multiplier" ? (
                  <span
                    className={`flex h-[24px] items-center justify-end px-[6px]  `}
                  >
                    {item[valueToGet] === "nan" || ""
                      ? ""
                      : Number(item[valueToGet]).toFixed(2)}
                  </span>
                ) : valueToGet === "company_name" ? (
                  <span
                    className={`flex h-[24px] w-[200px]  items-center justify-start truncate whitespace-nowrap px-[2px] `}
                  >
                    {item[valueToGet] && item[valueToGet] !== "nan"
                      ? item[valueToGet]?.length > 20
                        ? item[valueToGet].substring(0, 20) + "..."
                        : item[valueToGet]
                      : ""}
                  </span>
                ) : valueToGet === "caa_status" ||
                  valueToGet === "addl_status" ? (
                  <span
                    className={`flex h-[24px] items-center justify-center space-x-1 px-[2px]`}
                  >
                    <button
                      onClick={() => handleEdit(item)}
                      className="active:scale-90 "
                    >
                      <p
                        className={`${
                          (rowId?.row?.original?.caa_status === "P" &&
                            rowId?.row?.original?.addl_status === null) ||
                          (rowId?.row?.original?.caa_status === "P" &&
                            rowId?.row?.original?.addl_status === "O")
                            ? "cursor-pointer border-b-[1px] border-[#636363]"
                            : ""
                        }   text-[13px]  hover:border-orange-400 hover:text-orange-400`}
                      >
                        {(rowId?.row?.original?.caa_status === "P" &&
                          rowId?.row?.original?.addl_status === null) ||
                        (rowId?.row?.original?.caa_status === "P" &&
                          rowId?.row?.original?.addl_status === "O")
                          ? "Edit"
                          : item["caa_status"] === "P" &&
                            item["addl_status"] === null
                          ? "Pending"
                          : item["caa_status"] === "P" &&
                            item["addl_status"] === "O"
                          ? "Overdue"
                          : item["caa_status"] === "A" &&
                            item["addl_status"] === null
                          ? "Approved"
                          : item["caa_status"] === "R"
                          ? "Rejected"
                          : item["caa_status"] === "A" &&
                            item["addl_status"] === "S"
                          ? "Auto Approved"
                          : item["caa_status"] === "A" &&
                            item["addl_status"] === "F"
                          ? "Approved"
                          : ""}
                      </p>
                    </button>
                  </span>
                ) : valueToGet === "status" ? (
                  <span
                    className={`flex h-[24px] items-center justify-center px-[2px] `}
                  >
                    {item[valueToGet] ? "Active" : "Inactive"}
                  </span>
                ) : (
                  <span className="opacity-0">Divi</span>
                )}
              </span>
            ))}
          </span>
        )}
      </div>
    </>
  );
};

export default CellDropDown;
